export default __webpack_public_path__ + "static/media/corona.86559790.png";